import { render, staticRenderFns } from "./LocationManagement.vue?vue&type=template&id=510e5d6a&"
import script from "./LocationManagement.vue?vue&type=script&lang=js&"
export * from "./LocationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports